import { CheckCircle2 } from "lucide-react";
import { OFFERS, SECTORS, MODALITES, PREFERRED } from "../data/content";
import { SectionLabel, Reveal } from "../components/ui-bits";

export default function Offres() {
  return (
    <div data-testid="page-offres" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionLabel>Offres de service</SectionLabel>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[1.05]">
            Ce que je dirige,<br />décide et délivre.
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-2xl">
            Des interventions opérationnelles, pilotées par les résultats, des organisations qui rebondissent.
          </p>
        </Reveal>

        {/* Domaines de prédilection */}
        <Reveal className="mt-20">
          <SectionLabel>Secteurs d'intervention de prédilection</SectionLabel>
          <h2 className="mt-6 font-heading text-3xl md:text-4xl font-medium text-white">Là où je crée le plus de valeur.</h2>
        </Reveal>
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {PREFERRED.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div data-testid="preferred-card" className="bg-gradient-to-br from-blue-600/10 to-slate-900/40 border border-blue-500/20 rounded-2xl p-8 h-full">
                <div className="w-12 h-12 rounded-lg bg-blue-600/15 border border-blue-500/25 flex items-center justify-center">
                  <p.icon className="text-blue-400" size={22} />
                </div>
                <h3 className="mt-6 font-heading text-xl font-medium text-white leading-snug">{p.title}</h3>
                <p className="mt-3 text-slate-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Offers */}
        <div className="mt-16 space-y-6">
          {OFFERS.map((o, i) => (
            <Reveal key={o.num} delay={i * 0.05}>
              <div data-testid="offer-card" className="grid md:grid-cols-12 gap-8 bg-slate-900/40 border border-slate-800 rounded-2xl p-8 md:p-10 hover:border-blue-500/30 transition-colors">
                <div className="md:col-span-1">
                  <span className="font-heading text-2xl text-blue-500/70">{o.num}</span>
                </div>
                <div className="md:col-span-6">
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center shrink-0">
                      <o.icon className="text-blue-500" size={20} />
                    </div>
                    <h2 className="font-heading text-xl md:text-2xl font-medium text-white">{o.title}</h2>
                  </div>
                  <p className="mt-5 text-slate-400 leading-relaxed">{o.desc}</p>
                </div>
                {o.proofs.length > 0 && (
                  <div className="md:col-span-5">
                    <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-4">Preuves terrain</p>
                    <ul className="space-y-3">
                      {o.proofs.map((p) => (
                        <li key={p} className="flex items-start gap-3 text-sm text-slate-300">
                          <CheckCircle2 size={18} className="text-blue-500 shrink-0 mt-0.5" />
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        {/* Sectors */}
        <Reveal className="mt-24">
          <SectionLabel>Secteurs & métiers</SectionLabel>
          <h2 className="mt-6 font-heading text-3xl md:text-4xl font-medium text-white">
            Une amplitude singulière.
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {SECTORS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.08}>
              <div data-testid="sector-card" className="bg-slate-900/50 border border-slate-800 rounded-xl p-7 h-full hover:border-blue-500/30 transition-colors">
                <s.icon className="text-blue-500" size={26} />
                <h3 className="mt-5 font-heading text-lg font-medium text-white">{s.name}</h3>
                <p className="mt-2 text-sm text-slate-500">{s.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Modalités */}
        <Reveal className="mt-24">
          <div className="bg-gradient-to-br from-blue-600/10 to-slate-900/40 border border-blue-500/20 rounded-2xl p-8 md:p-12">
            <SectionLabel>Modalités d'intervention</SectionLabel>
            <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {MODALITES.map((m) => (
                <div
                  key={m.label}
                  data-testid="modalite-item"
                  className={m.label === "Contractualisation" ? "sm:col-span-2 lg:col-span-4" : ""}
                >
                  <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{m.label}</p>
                  <p className="mt-2 text-white font-heading text-lg">{m.value}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
